module.exports = {"130632100":"安新镇","130632101":"大王镇","130632102":"三台镇","130632103":"端村镇","130632104":"赵北口镇","130632105":"同口镇","130632106":"刘李庄镇","130632107":"安州镇","130632108":"老河头镇","130632200":"圈头乡","130632201":"寨里乡","130632202":"芦庄乡","130632203":"龙化乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130632.json
// module id = 252
// module chunks = 0